import PropTypes from 'prop-types';

export default function AccountStatus({ accountStatus }) {
  const textColor =
    accountStatus === 'approved'
      ? 'text-green-700'
      : accountStatus === 'denied'
      ? 'text-red-700'
      : '';

  return <p className={`capitalize ${textColor}`}>{accountStatus}</p>;
}

AccountStatus.propTypes = {
  accountStatus: PropTypes.string.isRequired,
};
